module.exports = __webpack_public_path__ + "static/media/logo-vaneau.372ba571.svg";